module.exports = __webpack_public_path__ + "img/btn-equatorial-grid.37de933f.svg";